








































































































import { Prop, Component, Mixins } from "vue-property-decorator";
import EstimateItemViewModel from "../presenters/estimate-item-view-model";
import EstimateRow from "./EstimateRow.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import Decimal from "decimal.js";

@Component({
  components: {
    EstimateRow
  }
})
export default class EstimateItem extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) item!: EstimateItemViewModel;
  @Prop({ default: 0 }) indent!: number;
  @Prop({ required: true }) unitOptions!: SelectOption[];
  @Prop({ required: true }) expenseCategoryOptions!: SelectOption[];

  get profitRatePercent(): string {
    if (!this.item.totalPrice) {
      return "0%";
    }
    return (
      new Decimal(this.item.totalPrice)
        .minus(this.item.loss)
        .div(this.item.totalPrice)
        .mul(100)
        .toFixed(1) + "%"
    );
  }

  calculate() {
    this.$emit("change");
  }
}
